// src/api/talent.js
const RAW_BASE = process.env.REACT_APP_API_BASE || "/server/exodia_uno_project_function";
const BASE = RAW_BASE.replace(/\/+$/, "");
const URLS = {
  list:   `${BASE}/list`,
  add:    `${BASE}/add`,
  update: `${BASE}/update`,
  remove: `${BASE}/delete`,
};

async function toJSON(res) {
  const t = await res.text();
  try { return t ? JSON.parse(t) : null; } catch { return t; }
}

const normalizeRow = (r) => r?.talents || r?.Talents || r;

export const TalentsAPI = {
  async list({ q } = {}) {
    // 👇 add a cache-buster & disable cache on fetch
    const urlBase = q ? `${URLS.list}?q=${encodeURIComponent(q)}` : URLS.list;
    const url = `${urlBase}${urlBase.includes('?') ? '&' : '?'}__t=${Date.now()}`;

    const res = await fetch(url, { cache: 'no-store' });
    const data = await toJSON(res);

    // Treat 304 like “use whatever we got,” which will be empty string if there’s no body
    if (res.status === 304) return Array.isArray(data) ? data : (data?.rows || []);

    if (!res.ok) throw new Error(data?.error?.message || data?.error || res.statusText);
    const rows = Array.isArray(data) ? data : (data?.rows || []);
    return rows.map(normalizeRow);
  },

  async create(body) {
    const res = await fetch(`${URLS.add}?__t=${Date.now()}`, {
      method: "POST",
      cache: 'no-store',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const data = await toJSON(res);
    if (!res.ok) throw new Error(data?.error?.message || data?.error || res.statusText);
    return data;
  },

  async update(ROWID, patch) {
    const res = await fetch(`${URLS.update}?__t=${Date.now()}`, {
      method: "PUT",
      cache: 'no-store',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ROWID, ...patch }),
    });
    const data = await toJSON(res);
    if (!res.ok) throw new Error(data?.error?.message || data?.error || res.statusText);
    return data;
  },

  async remove(ROWID) {
    const res = await fetch(`${URLS.remove}?__t=${Date.now()}`, {
      method: "DELETE",
      cache: 'no-store',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ROWID }),
    });
    const data = await toJSON(res);
    if (!res.ok) throw new Error(data?.error?.message || data?.error || res.statusText);
    return data;
  },
};
